import { Brain, LineChart, HeartPulse, GraduationCap, Network, Code2 } from 'lucide-react'

export const researchInterests = [
  {
    title: 'Artificial Intelligence for Human Support',
    description: 'Building AI systems that assist users in reflection, learning, and decision-making.',
    icon: Brain
  },
  {
    title: 'Human-Computer Interaction',
    description: 'Designing interfaces that feel clear, accessible, and emotionally intelligent.',
    icon: Network
  },
  {
    title: 'Data Visualization',
    description: 'Structuring complex information into visual systems that are easier to understand.',
    icon: LineChart
  },
  {
    title: 'Educational Technologies',
    description: 'Exploring how software can support learning, progress tracking, and knowledge discovery.',
    icon: GraduationCap
  },
  {
    title: 'Mental Health Technology',
    description: 'Studying how digital tools can support emotional reflection and responsible user guidance.',
    icon: HeartPulse
  },
  {
    title: 'Software Engineering Systems',
    description: 'Creating reliable full-stack systems with clean architecture and scalable development workflows.',
    icon: Code2
  }
]
